import { combineReducers } from 'redux';

import { homePageReducer } from '@components/HomePage';

import { carQuotePageReducer } from '@components/CarQuotePage';
import { carQuoteResultPageReducer } from '@components/CarQuoteResultPage';
import { carQuoteComparePageReducer } from '@components/CarQuoteComparePage';
import { carQuoteDetailsRouteReducer } from '@components/CarQuoteDetailsRoute';
import { carQuoteBuyRouteReducer } from '@components/CarQuoteBuyRoute';
import { CarQuotePaymentPageReducer } from '@components/CarQuotePaymentPage';

import { healthQuoteResultPageReducer } from '@components/HealthQuoteResultPage';
import { healthQuoteComparePageReducer } from '@components/HealthQuoteComparePage';
import { healthQuoteDetailsRouteReducer } from '@components/HealthQuoteDetailsRoute';
import { healthQuoteBuyRouteReducer } from '@components/HealthQuoteBuyRoute';
import { healthQuotePaymentPageReducer } from '@components/HealthQuotePaymentPage';

import { corporateHealthQuoteBuyRouteReducer } from '@components/CorporateHealthQuoteBuyRoute';

import { personalAccidentQuoteResultPageReducer } from '@components/PersonalAccidentQuoteResultPage';
import { personalAccidentQuoteDetailsPageReducer } from '@components/PersonalAccidentQuoteDetailsRoute';
import { personalAccidentQuoteBuyRouteReducer } from '@components/PersonalAccidentQuoteBuyRoute';
import { personalAccidentQuotePaymentPageReducer } from '@components/PersonalAccidentQuotePaymentPage';
import { personalAccidentQuoteComparePageReducer } from '@components/PersonalAccidentQuoteComparePage';

import { cancerQuoteResultPageReducer } from '@components/CancerQuoteResultPage';
import { cancerQuoteDetailsRouteReducer } from '@components/CancerQuoteDetailsRoute';
import { cancerQuoteBuyRouteReducer } from '@components/CancerQuoteBuyRoute';
import { cancerQuotePaymentPageReducer } from '@components/CancerQuotePaymentPage';
import { cancerQuoteComparePageReducer } from '@components/CancerQuoteComparePage';

import { generalQuoteBuyRouteReducer } from '@components/GeneralQuoteBuyRoute';
import { generalOrderPaymentPageReducer } from '@components/GeneralOrderPaymentPage';

import { insurancePolicyBuyRouteReducer } from '@components/InsurancePolicyBuyRoute';

import { authRouteReducer } from '@components/AuthRoute';
import { userDashboardRouteReducer } from '@components/UserDashboardRoute';
import { authReducer } from '@components/Auth';
import { abaPaywayReducer } from '@components/AbaPayway';
import { camDxReducer } from '@components/CamDxPage';
import { articlePageReducer } from '@components/ArticlePage';
import { articleDetailsPageReducer } from '@components/ArticleDetailsPage';
import { ToastProviderReducer } from '@components/ToastProvider';
import { photoManagerDialogReducer } from '@components/PhotoManagerDialog';
import { occupationReducer } from '@components/Occupation';
import { hospitalNetworkPageReducer } from '@components/HospitalNetworkPage';
import { garageNetworkPageReducer } from '@components/GarageNetworkPage';

import { featureCarReducer } from '@components/Feature/Car';
import { featureReducer } from '@components/Feature';

const rootReducer = combineReducers({
  homePageReducer,
  featureReducer,

  carQuotePageReducer,
  carQuoteResultPageReducer,
  carQuoteComparePageReducer,
  carQuoteDetailsRouteReducer,
  carQuoteBuyRouteReducer,
  CarQuotePaymentPageReducer,

  healthQuoteResultPageReducer,
  healthQuoteComparePageReducer,
  healthQuoteDetailsRouteReducer,
  healthQuoteBuyRouteReducer,
  healthQuotePaymentPageReducer,

  corporateHealthQuoteBuyRouteReducer,

  personalAccidentQuoteResultPageReducer,
  personalAccidentQuoteDetailsPageReducer,
  personalAccidentQuoteBuyRouteReducer,
  personalAccidentQuotePaymentPageReducer,
  personalAccidentQuoteComparePageReducer,

  cancerQuoteResultPageReducer,
  cancerQuoteDetailsRouteReducer,
  cancerQuoteBuyRouteReducer,
  cancerQuotePaymentPageReducer,
  cancerQuoteComparePageReducer,

  generalQuoteBuyRouteReducer,
  generalOrderPaymentPageReducer,

  insurancePolicyBuyRouteReducer,

  authRouteReducer,
  userDashboardRouteReducer,
  authReducer,
  abaPaywayReducer,
  camDxReducer,
  articlePageReducer,
  articleDetailsPageReducer,
  ToastProviderReducer,
  photoManagerDialogReducer,
  occupationReducer,
  hospitalNetworkPageReducer,
  garageNetworkPageReducer,

  featureCarReducer,
});

type RootState = ReturnType<typeof rootReducer>;

export { RootState };

export default rootReducer;
